export const getValueVocabulary = (value, defaultValue) => value || defaultValue;
